import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-4 m-auto w-4/5 items-center justify-center"
}
const _hoisted_2 = { class: "text-xs text-gray-700 text-left" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 1,
  class: "error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("form", {
    method: "post",
    class: "mb-0",
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.postChargeSerialCharging(_ctx.chargeConfig.url_code)), ["prevent"]))
  }, [
    (_ctx.formVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.chargeDescription), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.serialCode) = $event)),
            class: _normalizeClass(["h-8 w-full pl-2 b-0 text-s bg-white rounded-lg border-primary-main border text-gray-800", {
          'input-error': !!_ctx.errorMessage,
          'input-disabled': !_ctx.chargeable,
        }]),
            maxlength: "50",
            disabled: !_ctx.chargeable,
            required: ""
          }, null, 10, _hoisted_3), [
            [_vModelText, _ctx.serialCode]
          ])
        ]))
      : _createCommentVNode("", true),
    (!!_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_BaseButton, {
      class: "sm:w-2/5 my-4 w-4/5 justify-center",
      buttonClass: "main",
      disabled: !_ctx.chargeable
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.buttonLabel), 1)
      ]),
      _: 1
    }, 8, ["disabled"])
  ], 32))
}